module.exports = __webpack_public_path__ + "media/customizations/bryson/back-2c3d243e43ba766f17f676d48fb27e06.jpg";